import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../providers/rest.service';
import { ToastrService } from 'ngx-toastr';
import { Teklif } from '../model/teklif';
import { HelperProvider } from '../providers/helper.provider';
import { Page } from '../model/page';
import { Master } from '../model/master';
import { TeklifGirRequest } from '../model/teklif-gir-request';
import { TeklifKalemGirRequest } from '../model/teklif-kalem-gir-request';
import { TeklifKalem } from '../model/teklif-kalem';
import { AuthService } from '../auth/auth.service';
import { TeklifFiyatDegisiklik } from 'src/model/teklif-fiyat-degisiklik';

@Component({
  selector: 'app-teklif',
  templateUrl: './teklif.component.html',
  styleUrls: ['./teklif.component.css']
})
export class TeklifComponent implements OnInit, OnDestroy {

  public static ACTION_INCELE = 'incele';
  public static ACTION_TEKLIF_GIR = 'teklif-gir';
  public static ACTION_TEKLIF_REVIZE = 'teklif-revize';

  subscriptions: Subscription[] = [];
  id = null;
  publicAccessKey = null;
  teklif: Teklif = null;
  kalemler: TeklifKalem[] = null;
  totalTutarText = '0';
  teklifKalemler: TeklifKalem[];
  revizeEdilecekKalemler: TeklifFiyatDegisiklik[] = null;

  DURUM_INITIAL = Teklif.DURUM_INITIAL;
  DURUM_CEVAPLANDI = Teklif.DURUM_CEVAPLANDI;
  DURUM_RED = Teklif.DURUM_RED;
  DURUM_IPTAL = Teklif.DURUM_IPTAL;
  DURUM_REVIZE_EDILDI = Teklif.DURUM_REVIZE_EDILDI;

  ACTION_INCELE = TeklifComponent.ACTION_INCELE;
  ACTION_TEKLIF_GIR = TeklifComponent.ACTION_TEKLIF_GIR;
  ACTION_TEKLIF_REVIZE = TeklifComponent.ACTION_TEKLIF_REVIZE;

  currentAction = this.ACTION_INCELE;
  paraBirimleri: Master[] = null;
  odemeYontemleri: Master[] = null;
  teslimYerleri: Master[] = null;
  teslimSekilleri: Master[] = null;
  isAuthenticated = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private restService: RestService,
    private helperProvider: HelperProvider,
    private authService: AuthService,
    private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.isAuthenticated = this.authService.isLoggedIn();
    this.helperProvider.currentPage$.next(Page.Teklifler);
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.id = params.id;
      if (this.id != null && this.id !== '0') {
        this.getTeklif();
      } else {
        this.publicAccessKey = params.key;
        if (this.publicAccessKey != null) {
          this.getTeklif();
        } else {
          this.router.navigate(['404']);
        }
      }
      if (params.action != null) {
        switch (params.action) {
          case this.ACTION_TEKLIF_GIR:
          case this.ACTION_TEKLIF_REVIZE:
            this.currentAction = params.action;
        }
      }
    }));

    const types = [
      Master.ParaBirimi,
      Master.OdemeYontemi,
      Master.TeslimYeri,
      Master.TeslimSekli
    ];
    this.restService.getMasterTypes(types).subscribe(res => {
      if (res) {
        this.paraBirimleri = res.ParaBirimi?.map(x => new Master(x));
        this.odemeYontemleri = res.OdemeYontemi?.map(x => new Master(x));
        this.teslimYerleri = res.TeslimYeri?.map(x => new Master(x));
        this.teslimSekilleri = res.TeslimSekli?.map(x => new Master(x));
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getTeklif() {
    const subscription = res => {
      if (res) {
        this.teklif = res;
        // console.log(this.teklif.teslimYeri);
        if (this.teklif.teklifKalemler != null && this.teklif.teklifKalemler.length !== 0) {
          this.kalemler = this.teklif.teklifKalemler;

          if (this.currentAction === this.ACTION_TEKLIF_REVIZE) {
            this.teklifKalemler = [];
            this.kalemler.forEach(x => this.teklifKalemler.push(Object.assign({}, x)));
          }
        } else {
          if (this.teklif.talep != null && this.teklif.talep.talepKalemler != null) {
            this.kalemler = [];
            for (const talepKalem of this.teklif.talep.talepKalemler) {
              const teklifKalem = new TeklifKalem();
              teklifKalem.talepKalemId = talepKalem.id;
              teklifKalem.tutar = null;
              teklifKalem.paraBirimiId = null;
              teklifKalem.talepKalem = talepKalem;
              teklifKalem.stokKodu = talepKalem.stokKodu;
              teklifKalem.stokAdi = talepKalem.stokAdi;
              teklifKalem.olcuBirimi = talepKalem.olcuBirimi;
              this.kalemler.push(teklifKalem);
            }
          }

          // console.log(this.kalemler)
        }
        this.toplamTutarHesapla();

        if (this.publicAccessKey != null) {
          this.currentAction = this.ACTION_TEKLIF_GIR;
        }
      } else {
        this.router.navigate(['404']);
      }
    };

    if (this.id != null) {
      this.restService.teklif(this.id).subscribe(subscription);
    } else {
      this.restService.teklifByAccessKey(this.publicAccessKey).subscribe(subscription);
    }
  }

  talepDuzenle() {
    this.router.navigate(['talep'], { queryParams: { id: this.teklif.talep.id } });
  }

  teklifKaydet() {
    const request = new TeklifGirRequest();
    request.teklifId = this.teklif.id;
    request.teslimYeriId = this.teklif.teslimYeriId;
    request.teslimSekliId = this.teklif.teslimSekliId;
    // request.odemeYontemiId = this.teklif.odemeYontemiId;
    // request.teslimTarihi = this.teklif.teslimTarihi;
    request.opsiyon = this.teklif.opsiyon;
    request.garantiSuresi = this.teklif.garantiSuresi;
    request.firmaTeklifNotu = this.teklif.firmaTeklifNotu;
    request.teslimSuresi = this.teklif.teslimSuresi;

    const kalemler: TeklifKalemGirRequest[] = [];
    if (this.kalemler != null) {
      for (const talepKalem of this.kalemler) {
        const kalem = new TeklifKalemGirRequest();
        kalem.teklifKalemId = talepKalem.id;
        kalem.talepKalemId = talepKalem.talepKalemId;
        kalem.birimFiyati = talepKalem.tutar;
        kalem.paraBirimiId = talepKalem.paraBirimiId;
        kalemler.push(kalem);
      }
    }
    request.kalemler = kalemler;
    request.publicAccessKey = this.publicAccessKey;

    if (this.currentAction === this.ACTION_TEKLIF_REVIZE) {
      this.revizeEdilecekKalemler = [];
      
      for (const k of kalemler) {
        const index = this.teklifKalemler.findIndex(x => x.id === k.teklifKalemId && (x.tutar !== k.birimFiyati || x.paraBirimiId !== k.paraBirimiId));
        if (index !== -1) {
          const revizeKalemler = new TeklifFiyatDegisiklik();
          revizeKalemler.teklifKalemId = this.teklifKalemler[index].id;
          revizeKalemler.fiyat = this.teklifKalemler[index].tutar;
          revizeKalemler.paraBirimiId = this.teklifKalemler[index].paraBirimiId;

          this.revizeEdilecekKalemler.push(revizeKalemler);
        }
      }
      request.teklifFiyatDegisiklikler = this.revizeEdilecekKalemler;
    }

    this.restService.teklifKaydet(request).subscribe(res => {

      // this.restService.fiyatDegisiklikKaydet(this.revizeEdilecekKalemler).subscribe(res => {
      //   console.log("ok");
      // });

      this.toastrService.show('Kaydedildi', 'Başarılı');
      if (this.isAuthenticated) {
        this.router.navigate(['teklif-olusturuldu'], { queryParams: { id: this.teklif.id } });
      } else {
        this.router.navigate(['teklif-olusturuldu'], { queryParams: { key: this.publicAccessKey } });
      }
    });
  }

  toplamTutarHesapla() {
    const array: ParaBirimiTutar[] = [];
    if (this.paraBirimleri) {
      for (const pb of this.paraBirimleri) {
        array.push(new ParaBirimiTutar(pb, 0));
      }
    }
    if (this.kalemler != null) {
      for (const t of this.kalemler) {
        const index = array.findIndex(x => x.paraBirimi.id === t.paraBirimiId);
        if (index !== -1) {
          array[index].tutar += t.tutar * t.talepKalem.talepEdilen;
        }
      }
    }
    const textArray = [];
    for (const e of array) {
      if (e.tutar !== 0) {
        textArray.push(`${e.tutar.toLocaleString('tr-TR')} ${e.paraBirimi.aciklama}`);
      }
    }
    this.totalTutarText = textArray.join(' + ');
  }

  teklifDuzenle() {
    this.currentAction = this.ACTION_TEKLIF_REVIZE;
  }

  teklifGir() {
    this.currentAction = this.ACTION_TEKLIF_GIR;
  }

  talepGit() {
    this.router.navigate(['talep'], { queryParams: { id: this.teklif.talep.id } });
  }

  downloadFile(fileName: string) {
    this.restService.downloadFile(fileName).subscribe(res => {
    });
  }
}

export class ParaBirimiTutar {
  paraBirimi: Master;
  tutar: number;
  toplamTutar: number;

  constructor(paraBirimi: Master, tutar: number, toplamTutar: number = null) {
    this.paraBirimi = paraBirimi;
    this.tutar = tutar;
    this.toplamTutar = toplamTutar;
  }
}